'use es6';

import { Record, Map as ImmutableMap } from 'immutable';
const formatContactProperties = properties => Record(Object.assign({}, properties, {
  groups: ImmutableMap(properties.groups)
}))();
export default formatContactProperties;